// deps
import React, { memo } from "react";
import classNames from "classnames";
import { AriaHidden } from "@swiggy-private/core-ui";

import { Icon, IconImg } from "./styles.v4";

export interface TurboPaymentMethodIconProps {
    /**
     * className to be applied on icon
     */
    className?: string;
    /**
     * Icon Image url
     */
    src?: string;
    /**
     * Icon Width
     */
    width?: number;
    /**
     * Icon Height
     */
    height?: number;
    alt?: string;
    parentClassName?: string;
    imgClassName?: string;
    customLogo?: boolean;
    "data-testid"?: string;
}

function TurboPaymentMethodIcon(props: TurboPaymentMethodIconProps): React.ReactElement | null {
    const { className, src, width, alt, height, customLogo, parentClassName, imgClassName } = props;
    if (className === undefined && src === undefined) {
        return null;
    }

    if (customLogo && className) {
        return (
            <AriaHidden as="div" className={classNames(className, parentClassName)} data-testid={props["data-testid"]}>
                {src && (
                    // TODO: Use DLS Image component instead of IconImg
                    <img
                        alt={alt}
                        crossOrigin="anonymous"
                        className={imgClassName}
                        src={src}
                        width={width}
                        height={height}
                    />
                )}
            </AriaHidden>
        );
    }

    return (
        <Icon className={parentClassName} data-testid={props["data-testid"]} aria-hidden="true">
            {className !== undefined ? (
                <div className={className} />
            ) : (
                // TODO: Use DLS Image component instead of IconImg
                <IconImg
                    alt={alt}
                    crossOrigin="anonymous"
                    className={imgClassName}
                    src={src}
                    width={width}
                    height={height}
                />
            )}
        </Icon>
    );
}

export default memo<TurboPaymentMethodIconProps>(TurboPaymentMethodIcon);
